<template>
  <div class="course-category-task" @click.stop="taskClick">
    <div class="tag" v-if="taskData && taskData.activityTypeLabel">
      {{ taskData.activityTypeLabel }}
    </div>
    <div class="task-name">
      {{ taskData && taskData.title }}
    </div>
    <div class="task-state-label">
      <div class="label-item">
        <img v-if="isShowFinishIcon" class="finish-icon" :src="iconFinishTask" />
        <div v-else-if="isShowLearning" class="state-label-text">进行中</div>
      </div>
    </div>
  </div>
</template>

<script>
import iconFinishTask from '@/assets/images/boss-underStudent/true.png'
export default {
  name: 'CourseCategoryTask',
  props: {
    taskData: {
      type: Object
    },
  },
  data() {
    return {
      iconFinishTask,
    }
  },
  computed: {
    isShowFinishIcon () {
      return this.taskData.learningStatus && this.taskData.learningStatus === '1'
    },
    isShowLearning () {
      return this.taskData.learningStatus && this.taskData.learningStatus === '2'
    }
  },
  methods: {
    taskClick () {
      this.$emit('taskClick', this.taskData)
    }
  }
}
</script>

<style lang="less" scoped>
.course-category-task {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #1f333f;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #f1f1f1;
  position: relative;

  .tag {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 13px;
    padding: 0 4px;
    height: 16px;
    background: #ffffff;
    border: 1px solid #EB1700;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
    color: #fe6a23;
  }

  .task-name {
    margin-right: 13px;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .task-state-label {
    .label-item {
      display: flex;
      align-items: center;

      .click-btn {
        padding: 2px 7px;
        color: #ffffff;
        background: #EB1700;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 500;
        line-height: 16px;
      }

      .finish-icon {
        width: 16px;
        height: 16px;
      }

      .state-label-text {
        font-size: 11px;
        font-weight: 500;
        color: #EB1700;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/course/components/CourseCategoryTask.vue